<template>
    <div>
        <div class="d-flex" id="content-wrapper">
            <Sidebar :should-render="showBottomBar" />
            <!-- <Mobilebar :should-render="showMobile" @close="closeMobileBar()" /> -->

            <div class="w-100 ml-3">
                <nav id="mainNav" class="navbar navbar-expand-sm  navbar-dark navbar-expand-md  justify-content-left">
                    <a class="navbar-brand" v-if="showLogo"><img class="img-fluid" src="@/assets/logo.png"
                            width="120"></a>
                    <a v-if="!showLogo" class="nav-link click menu-items d-flex align-items-center justify-content-left"
                        href="#" @click="toggleMenu()">
                        <span class="material-icons md-24 mr-1">menu_open</span>
                        hide menu
                    </a>
                    <a v-else class="nav-link click menu-items d-flex align-items-center justify-content-left" href="#"
                        @click="toggleMenu()">
                        <span class="material-icons md-24 mr-1">menu</span>
                        show menu
                    </a>
                    <Dark/>
                    
                </nav>

                <nav id="mobileNav" class="navbar navbar-expand-sm  navbar-dark navbar-expand-md  justify-content-left">
                    <a class="navbar-brand"><img class="img-fluid" src="@/assets/logo.png"
                            width="120"></a>
                    <a class="nav-link click menu-items d-flex align-items-center justify-content-left" href="#"
                        @click="toggleMobile()">
                        <span class="material-icons md-24 mr-1">menu</span>
                        show menu
                    </a>
                    <Dark/>
                </nav>

                <div class="home container-fuid mb-5 mr-5 ml-5">

                    <div class="row" v-if="displayMessages">
                        <div class="col-md-12 text-center mt-5 mb-5">
                            <transition name="fade">
                                <span class="alert-danger" v-if="showErrorMessage">{{errorMessage}}</span>
                                <span class="alert-success" v-if="showSuccessMessage">{{successMessage}} </span>
                                <span class="alert-info" v-if="showInfoMessage">{{successInfo}}</span>
                            </transition>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-md-4 mt-3">
        
                            <div class="card card-click mt-3 h-100 mb-3" @click="filterBy('opened')">
                                <div class="card-body">
                                    <h2>🚀</h2>
                                    <h1 class="text-center">{{totalEvents}}</h1>
                                    <p class="text-muted text-center">
                                        <small>Opened</small>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mt-3">
                            <div class="card card-click mt-3 h-100 mb-3" @click="filterBy('inRepair')">
                                <div class="card-body">
                                    <h2>🧰</h2>
                                    <h1 class="text-center">{{totalRepair}}</h1>
                                    <p class="text-muted text-center">
                                        <small>In repair</small>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mt-3">
                            <div class="card card-click mt-3 h-100 mb-3" @click="filterBy('closed')">
                                <div class="card-body">
                                    <h2>✅</h2>
                                    <h1 class="text-center">{{totalClosed}}</h1>
                                    <p class="text-muted text-center">
                                        <small>Closed</small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
        
        
                        <div class="col-md-4 mt-3">
                            <div class="card h-100">
                                <div class="card-body">
                                    <h2 class="text-l">🔎</h2>
                                    <h5 class="text-center"><strong>Search filters</strong></h5>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="">PO</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50" v-model.trim="sPo">
                                            </div>
                                            <div class="form-group">
                                                <label for="">Job name</label>
                                                <select class="form-control form-control-sm" v-model="sJob">
                                                    <option value="x" selected>--Select a value--</option>
                                                    <option v-for="(item, index) in sJobs" :key="index" :value="item">{{item}}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label for="">S/N</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50" v-model="sSn">
                                            </div>
                                            <div class="form-group">
                                                <label for="">Tech/Employee</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50" v-model="sTech">
                                            </div>
                                            <div class="form-group mb-3">
                                                <vs-button block @click="search()">Search</vs-button>
                                            </div>
                                            <hr/>
                                            <p class="text-center">
                                                <a class="click text-center" @click="resetTable()"><i class="fas fa-sync-alt"></i> Reset SN and search table</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="col-md-8 mt-3">
                            <div class="card h-100">
                                <div class="card-body">
                                    <h2 class="text-l"> 🏢</h2>
                                    <h5 class="text-center"><strong>Register a new Repair </strong> 
                                        <template v-if="serialNumber=='0'">
                                            <span class="green">--</span>
                                        </template>
                                        <template v-else>
                                            <span class="green">{{serialNumber}}</span>
                                        </template>
                                    </h5>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="card mb-3 mt-3" v-if="serialNumber!='0'">
                                                <div class="card-body">
                                                    <template v-if="serialNumber!='0'">
                                                        <p class="text-center"><strong>📇 Inventory Info</strong></p>
                                                        <hr/>  
                                                        <ul class="list-group">
                                                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                                                <strong>Ticket Id:</strong><span>{{ticketId}}</span>
                                                            </li>
                                                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                                                <strong>Serial Number:</strong><span>{{serialNumber}}</span>
                                                            </li>
                                                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                                                <strong>Status:</strong>       <template v-if="ticketStatus==1">
                                                                    <span class="gray"><strong></strong>🚀 opened</span>
                                                                </template>
                                                                <template v-if="ticketStatus==2">
                                                                    <span class="purple"><strong></strong>🧰 in repair</span>
                                                                </template>
                                                                <template v-if="ticketStatus==3">
                                                                    <span class="green"><strong></strong>✅ closed</span>
                                                                </template> 
                                                            </li>
                                                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                                                <strong>Date:</strong><span>{{sendDate}}</span>
                                                            </li>
                                                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                                                <strong>Job name:</strong><span>{{invJobName}}</span>
                                                            </li>
                                                            <li class="list-group-item">
                                                                <strong>Sent notes:</strong><br>{{invNotes}}
                                                            </li>
                                                        </ul>
                  
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Date of Work Order</label>
                                                <datetime input-class="form-control form-control-sm" type="datetime"  format="yyyy-MM-dd HH:mm" :value-zone="timeZ" v-model="workDate"></datetime>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Tech/Employee</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50" v-model.trim="tech">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Job Name</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50" v-model.trim="jobName">
                                            </div>
                                        </div>
        
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">PO #</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50" v-model.trim="po">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Contact Name</label>
                                                <input class="form-control form-control-sm" type="text" maxlength="50" v-model.trim="contactName">
                                            </div>
                                        </div>
        
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Contact #</label>
                                                <input class="form-control form-control-sm" v-mask="'###-###-####'" type="text" maxlength="50" v-model.trim="contactNumber" >
                                            </div>
                                        </div>
        
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="">Unit Description</label>
                                                <select class="form-control form-control-sm" v-model="unitDesc">

                                                    <option value="x">Select a value</option>
                                                    <option value="12 Station M DC">12 Station M DC</option>
                                                    <option value="24 Station M DC">24 Station M DC</option>
                                                    <option value="12 Station M AC">12 Station M AC</option>
                                                    <option value="24 Station M AC">24 Station M AC</option>
                                                    <option value="ACE">ACE</option>
                                                    <option value="Piccolo 1/1">Piccolo 1/1</option>
                                                    <option value="Piccolo 2/2">Piccolo 2/2</option>
                                                    <option value="Piccolo 4/4">Piccolo 4/4</option>
                                                    <option value="XPR5350e">XPR5350e</option>
                                                    <option value="CP200">CP200</option>
                                                    <option value="n/a">n/a</option>
                                                </select>
                                            </div>
                                        </div>
        
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <vs-checkbox v-model="analogBoard">
                                                    Analog Board
                                                </vs-checkbox>
                                            </div>
                                        </div>
        
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="">Issue Reported</label>
                                                <textarea class="form-control form-control-sm" maxlength="180" v-model="issueReported" cols="30" rows="10"></textarea>
                                            </div>
                                        </div>
        
                                        <div class="col-md-12">
                                            <h4>Dates</h4>
                                            <hr/>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group">
                                                <label for="">Start Time</label>
                                                <datetime input-class="form-control form-control-sm" type="datetime"  format="yyyy-MM-dd HH:mm" :value-zone="timeZ" v-model="startTime"></datetime>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <div class="form-group">
                                                <label for="">Stop Time</label>
                                                <datetime input-class="form-control form-control-sm" type="datetime"  format="yyyy-MM-dd HH:mm" :value-zone="timeZ" v-model="stopTime"></datetime>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-sm-12 d-flex align-items-center">
                                            <div class="form-group">
                                                <vs-button info border @click="addDate()">Add Date</vs-button>
                                            </div>
                                        </div>
        
                                        <div class="col-md-12">
                                            <ul class="list-group">
                                                <li class="list-group-item" v-for="(item, index) in dates" :key="index">
                                                    <strong>From:</strong> {{ moment(item.startTime).format('YYYY-MM-DD HH:mm:ss') }} <strong>to:</strong> {{ moment(item.stopTime).format('YYYY-MM-DD HH:mm:ss') }} <button class="btn btn-sm btn-danger" @click="delDate(index)"><i class="fa fa-trash"></i></button>
                                                </li>
                                            </ul>
                                        </div>
                                        
        
        
                                        <div class="col-md-12 mt-3">
                                           <label for="">Repair status</label>
                                                <div class="form-group">
                                                    <div class="form-check">
                                                        <label class="form-check-label">
                                                            <input type="radio" class="form-check-input" name="optradio" v-model="statusTicket" value="1">Opened
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <label class="form-check-label">
                                                            <input type="radio" class="form-check-input" name="optradio"
                                                                v-model="statusTicket" value="2">In repair
                                                        </label>
                                                    </div>
                                                    <div class="form-check">
                                                        <label class="form-check-label">
                                                            <input type="radio" class="form-check-input" name="optradio" v-model="statusTicket" value="3">Closed
                                                        </label>
                                                    </div>
                                                </div>
                                        </div>
                                        <div class="col-md-12 mt-3">
                                            <div class="form-group">
                                                <label for="">Description of Work Done</label>
                                                <textarea class="form-control form-control-sm" maxlength="1000" v-model="description" cols="30" rows="10"></textarea>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <template v-if="serialNumber!=0">
                                                    <vs-button block @click="registerTicket()">Register Repair</vs-button>
                                                </template>
                                                <template v-else>
                                                    <p class="text-muted">You must register and select a Serial Number from 'Inventory Screen'. You can click <router-link to="/qr">here</router-link> to go there.</p>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
        
                        <div class="col-md-12 mt-3">
                            <div class="card mt-5">
                                <div class="card-body" v-if="showTable">
                                    <h3 class="mt-3 mb-3">Repairs Data -  <span><small><a class="btn btn-dark text-white click text-center" @click="resetTable()"><i class="fas fa-sync-alt"></i> Reset search table</a></small></span> </h3> 
                                    
                                    <vs-table>
                                        <template #thead>
                                          <vs-tr>
                                            <vs-th>
                                                repairID
                                            </vs-th>
                                            <vs-th class="tableInfo">
                                                S/N
                                            </vs-th>
                                            <vs-th>
                                                Date Work Order
                                            </vs-th>
        
                                            <vs-th class="tableInfo">
                                                Tech
                                            </vs-th>
        
                                            <vs-th>
                                                Job
                                            </vs-th>
                                            
                                            <vs-th class="tableInfo">
                                                PO
                                            </vs-th>
                                            
                                            <vs-th class="tableInfo">
                                                Contact
                                            </vs-th>
                                            <vs-th class="tableInfo">
                                                Contact #
                                            </vs-th>
                                            <vs-th>
                                                Status
                                            </vs-th>
                                            <vs-th>
                                                Operations
                                            </vs-th>
                                          </vs-tr>
                                        </template>
                                        <template #tbody>
                                          <vs-tr
                                            :key="indextr"
                                            v-for="(tr, indextr) in tickets"
                                            :data="tr"
                                          >
                                          <vs-td class="text-center">  
                                                <a class="click ticketLink" @click="seeDetails(tickets[indextr])">{{tickets[indextr].id}}</a>
                                            </vs-td>
                    
                                            <vs-td  class="text-center tableInfo">  
                                                <a class="click ticketLink" @click="seeDetails(tickets[indextr])">{{tickets[indextr].sn}}</a>
                                            </vs-td>
                    

                                            <vs-td>
                                                {{ moment(tickets[indextr].workDate).format('YYYY-MM-DD HH:mm:ss') }}
                                            </vs-td>
                                            
                                            <vs-td class="tableInfo">
                                                {{tickets[indextr].tech}}
                                            </vs-td>
                    
                                            <vs-td>
                                                {{tickets[indextr].jobName}}
                                            </vs-td>
                    
                                            <vs-td class="tableInfo">
                                                {{tickets[indextr].po}}
                                            </vs-td>

                                            <vs-td class="tableInfo">
                                                    {{tickets[indextr].contactName}}
                                            </vs-td>
                                            <vs-td class="tableInfo">
                                                    {{tickets[indextr].contactNumber}}
                                            </vs-td>

                    
                                            <vs-td>
                                                <template v-if="tickets[indextr].status==1">
                                                    <span class="gray">🚀 opened</span>
                                                </template>
                                                <template v-if="tickets[indextr].status==2">
                                                    <span class="purple">🧰 in repair</span>
                                                </template>
                                                <template v-if="tickets[indextr].status==3">
                                                    <span class="green">✅ closed</span>
                                                </template>
                                            </vs-td>
                                                                
                                            <vs-td>
                                                <!-- <a class="btn btn-block btn-sm btn-dark" :href="'https://quantumsync.org/api-agt/printWorkOrder.php?printWorkOrder=true&id=' + tickets[indextr].id + '&serial=' + serialNumber + '&ticket=' + ticketId " target="_blank"> <i class="fas fa-print"></i> Work Order</a> -->
                                                <button class="btn btn-block btn-sm btn-dark" @click="printOrder(tickets[indextr].id)"> <i class="fas fa-print"></i> Work Order</button>
                                                <button class="btn btn-block btn-sm btn-danger" @click="delTicket(tickets[indextr].id, tickets[indextr].sn)" v-if="remEmail=='dianar@ag-tronix.com' || remEmail=='lorenzo.are@gmail.com' || remEmail=='scottf@ag-tronix.com' || remEmail=='jamier@ag-tronix.com'"> <i class="fa fa-trash"></i> Delete</button>
                                            </vs-td>
                                          </vs-tr>
                                        </template>
                                      </vs-table>
                                    
                                        <!-- <vs-table class="mt-3" search :data="tickets"  stripe  maxHeight max-items="25" >
                                            <template slot="header">
                                                <h5 class="mt-3 ml-3">
                                                    <strong>Repairs</strong>
                                                </h5>
                                            </template>
                                            <template slot="thead">
                                                <vs-th sort-key="ticketId">
                                                    repairID
                                                </vs-th>
                                                <vs-th sort-key="ticketId">
                                                    S/N
                                                </vs-th>
                                                <vs-th sort-key="sentDate">
                                                    Date Work Order
                                                </vs-th>
            
                                                <vs-th sort-key="companyName">
                                                    Tech
                                                </vs-th>
            
                                                <vs-th sort-key="jobName">
                                                    Job
                                                </vs-th>
                                                
                                                <vs-th sort-key="sn">
                                                    PO
                                                </vs-th>
                                                
                                                <vs-th sort-key="statusLabel">
                                                    Contact
                                                </vs-th>
                                                <vs-th sort-key="user">
                                                    Contact #
                                                </vs-th>
                                                <vs-th sort-key="status">
                                                    Status
                                                </vs-th>
                                                <vs-th>
                                                    Operations
                                                </vs-th>
                                            </template>
                            
                                            <template slot-scope="{data}">
                                                <vs-tr :key="indextr" v-for="(tr, indextr) in data"> 
            
                                                    <vs-td :data="data[indextr].id" class="text-center">  
                                                        <a class="click ticketLink" @click="seeDetails(data[indextr])">{{data[indextr].id}}</a>
                                                    </vs-td>
                            
                                                    <vs-td :data="data[indextr].sn" class="text-center">  
                                                        <a class="click ticketLink" @click="seeDetails(data[indextr])">{{data[indextr].sn}}</a>
                                                    </vs-td>
                            
            
                                                    <vs-td :data="moment(data[indextr].workDate).format('YYYY-MM-DD HH:mm:ss')">
                                                        {{ moment(data[indextr].workDate).format('YYYY-MM-DD HH:mm:ss') }}
                                                    </vs-td>
                                                    
                                                    <vs-td :data="data[indextr].tech">
                                                        {{data[indextr].tech}}
                                                    </vs-td>
                            
                                                    <vs-td :data="data[indextr].jobName">
                                                        {{data[indextr].jobName}}
                                                    </vs-td>
                            
                                                    <vs-td :data="data[indextr].po">
                                                        {{data[indextr].po}}
                                                    </vs-td>
            
                                                    <vs-td :data="data[indextr].contactName">
                                                            {{data[indextr].contactName}}
                                                    </vs-td>
                                                    <vs-td :data="data[indextr].contactNumber">
                                                            {{data[indextr].contactNumber}}
                                                    </vs-td>
            
                            
                                                    <vs-td :data="data[indextr].status">
                                                        <template v-if="data[indextr].status==1">
                                                            <vs-chip closable color="#1D1C1C" close-icon="edit">
                                                                Opened
                                                            </vs-chip>
                                                        </template>
                                                        <template v-if="data[indextr].status==2">
                                                            <vs-chip closable color="#514E7E" close-icon="alarm">
                                                            In repair
                                                            </vs-chip>
                                                        </template>
                                                        <template v-if="data[indextr].status==3">
                                                            <vs-chip closable color="#24c1a0" close-icon="check">
                                                                Closed
                                                            </vs-chip>
                                                        </template>
                                                    </vs-td>
                                                                        
                                                    <vs-td>
                                                        <a class="btn btn-block btn-sm btn-dark"
                                                        :href="'https://quantumsync.org/api-agt/printWorkOrder.php?printWorkOrder=true&id=' + data[indextr].id"
                                                            target="_blank"> <i class="fas fa-print"></i> Work Order</a>
                                                        <button class="btn btn-block btn-sm btn-danger" @click="delTicket(data[indextr].id, data[indextr].sn)"> <i class="fa fa-trash"></i> Delete</button>
                                                    </vs-td>
                                                </vs-tr>
                                            </template>
                                        </vs-table> -->
        
                                    <div class="text-center mt-2">
                                        <!-- <vs-pagination :total="totalTickets" v-model="currentx"></vs-pagination> -->
                                        <v-pagination v-model="currentx" :page-count="totalTickets"></v-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
        
        
                    </div>
                </div>
            </div>
            
        </div>




        <vs-dialog  title="Qr Scanner" v-model="openCamera">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h3>Scan a Qr</h3>
                        <qrcode-stream @decode="onDecode" @init="onInit" v-if="openCamera" />
                    </div>
                </div>
            </div>
        </vs-dialog>
       


        <vs-dialog  v-model="pDetails">
            <div class="container-fluid m-3">
                <div class="row" v-if="displayMessages2">
                    <div class="col-md-12 text-center mt-5 mb-5">
                        <transition name="fade">
                            <span class="alert-danger" v-if="showErrorMessage2">{{errorMessage2}}</span>
                            <span class="alert-success" v-if="showSuccessMessage2">{{successMessage2}} </span>
                            <span class="alert-info" v-if="showInfoMessage2">{{successInfo2}}</span>
                        </transition>
                    </div>
                </div>
                <div class="row">           
                    <div class="col-md-12">
                        <h3>Repair #{{selectedTicket}} - <span class="text-danger">{{snSelected}}</span> </h3>
                    </div>         
                    <div class="col-md-6">
                        <h4 class="text-muted">Main Data</h4>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for=""><strong>Date of Work Order</strong></label>
                                    {{workDateSelected}}
                                    <!-- <datetime input-class="form-control form-control-sm" type="datetime"
                                        :value-zone="timeZ" v-model="workDateSelected"></datetime> -->
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for=""><strong>Tech/Employee</strong></label>
                                    <input class="form-control form-control-sm" type="text" maxlength="50" v-model.trim="techSelected">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for=""><strong>Job Name</strong></label>
                                    <input class="form-control form-control-sm" type="text" maxlength="50" v-model.trim="jobNameSelected">
                                </div>
                            </div>
                        
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for=""><strong>PO #</strong></label>
                                    <input class="form-control form-control-sm" type="text" maxlength="50" v-model.trim="poSelected">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for=""><strong>Contact Name</strong></label>
                                    <input class="form-control form-control-sm" type="text" maxlength="50" v-model.trim="contactNameSelected">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for=""><strong>Contact #</strong></label>
                                    <input class="form-control form-control-sm" v-mask="'###-###-####'" type="text" maxlength="50"
                                        v-model.trim="contactNumberSelected">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="">Unit Description</label>
                                    <select class="form-control form-control-sm" v-model="unitDescSelected">
                            
                                        <option value="x">Select a value</option>
                                        <option value="12 Station M DC">12 Station M DC</option>
                                        <option value="24 Station M DC">24 Station M DC</option>
                                        <option value="12 Station M AC">12 Station M AC</option>
                                        <option value="24 Station M AC">24 Station M AC</option>
                                        <option value="ACE">ACE</option>
                                        <option value="Piccolo 1/1">Piccolo 1/1</option>
                                        <option value="Piccolo 2/2">Piccolo 2/2</option>
                                        <option value="Piccolo 4/4">Piccolo 4/4</option>
                                        <option value="XPR5350e">XPR5350e</option>
                                        <option value="CP200">CP200</option>
                                        <option value="n/a">n/a</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div class="col-md-12">
                                <div class="form-group">
                                    <vs-checkbox v-model="analogBoardSelected">
                                        Analog Board
                                    </vs-checkbox>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for=""><strong>Issue Reported</strong></label>
                                        <textarea class="form-control form-control-sm" maxlength="180" v-model="issueReportedSelected" cols="30" rows="10"></textarea>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for=""><strong>Description of Work Done</strong></label>
                                        <textarea class="form-control form-control-sm" maxlength="1000"  v-model="descriptionSelected" cols="30" rows="10"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for=""><strong class="mr-2">Status: </strong></label>
                            <template v-if="statusTicketChange==1">
                                <span class="gray"><strong></strong>🚀 opened</span>
                            </template>
                            <template v-if="statusTicketChange==2">
                                <span class="purple"><strong></strong>🧰 in repair</span>
                            </template>
                            <template v-if="statusTicketChange==3">
                                <span class="green"><strong></strong>✅ closed</span>
                            </template>

                            <div class="form-check">
                                <label class="form-check-label">
                                    <input type="radio" class="form-check-input" name="optradio" v-model="statusTicketChange" value="1" >Opened
                                </label>
                            </div>
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input type="radio" class="form-check-input" name="optradio" v-model="statusTicketChange" value="2" >In repair
                                </label>
                            </div>
                            <div class="form-check">
                                <label class="form-check-label">
                                    <input type="radio" class="form-check-input" name="optradio" v-model="statusTicketChange" value="3" >Closed
                                </label>
                            </div>
                        </div>
                        <div class="form-group">
                            <vs-button block @click="createChange()">Save Changes</vs-button>
                        </div>

                        
                    </div>

                    <div class="col-md-6">
                        <h4 class="text-muted">Tracking times</h4>
                        <table class="table table-striped">
                            <thead>
                              <tr>
                                <th>Start time</th>
                                <th>Stop time</th>
                                <th>Operations</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in trackHistory" :key="index">
                                <td>{{item.start}}</td>
                                <td>{{item.end}}</td>
                                <td>
                                    <button class="btn btn-block btn-sm btn-danger" @click="delTime(item.id, item.repairId)"><i class="fa fa-trash"></i> Delete</button> 
                                </td>
                              </tr>
                            </tbody>
                        </table>

                        <hr/>
                        <h3>Add time event</h3>
                        <div class="form-group">
                            <label for="">Start time</label>
                            <datetime input-class="form-control form-control-sm" type="datetime"  format="yyyy-MM-dd HH:mm" :value-zone="timeZ" v-model="moreStart"></datetime>
                        </div>
                        <div class="form-group">
                            <label for="">Stop time</label>
                            <datetime input-class="form-control form-control-sm" type="datetime"  format="yyyy-MM-dd HH:mm" :value-zone="timeZ" v-model="moreStop"></datetime>
                        </div>

                        <div class="form-group">
                            <vs-button block @click="addMoreTime()">Add Time</vs-button>
                        </div>
                    </div>
                </div>
            </div>
          </vs-dialog>


        <vs-dialog  title="Add event" :active.sync="ptrack">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="">Event date</label>
                            <datetime input-class="form-control form-control-sm" type="datetime"  format="yyyy-MM-dd HH:mm" :value-zone="timeZ" v-model="eventDate"></datetime>
                        </div>
                        <div class="form-group">
                            <label for="">PO/INV</label>
                            <input type="text" class="form-control"  v-model="po" >
                        </div>
                        <div class="form-group">
                            <label for="">Aditional notes <small class="text-muted">You can describe details of event date here.</small></label>
                            <textarea class="form-control form-control-sm" maxlength="180" v-model="aditionalNotes" cols="30" rows="10"></textarea>
                        </div>
                        <div class="form-group">
                            <button class="btn btn-dark btn-block mt-3" @click="addDetails()"><i class="far fa-save"></i> Add Event</button>
                        </div>
                    </div>
                </div>
            </div>
          </vs-dialog>


          <vs-dialog v-model="pDelTicket">
            <div class="container dDel">
      
                <div class="row">
                    <div class="col-md-12 mt-3">
                        <h4 class="not-margin"> 🗑️Delete <b>ticket</b></h4>
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <p>Are you sure you want to delete all data associated with ticket #{{selectedTicket}}? <br>
                        <small>Associated data included <strong>aditional info will be deleted.</strong></small></p>
                    </div>
      
                </div>
      
                <vs-button block @click="confirmDel()">
                    Yes, delete it!
                </vs-button>
                <vs-button danger block @click="pDelTicket=false">
                    Cancel
                </vs-button>
            </div>
        </vs-dialog>
    

  
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
    import { firebaseApp } from "../fb";
    import Sidebar from "@/components/Sidebar.vue";
    import Mobilebar from "@/components/Mobilebar.vue";
    import Navbar from "@/components/Navbar.vue";
    import validator from "validator";
    import axios from 'axios';
    import { Datetime } from 'vue-datetime';
    import Multiselect from 'vue-multiselect'
    import { QrcodeStream } from 'vue-qrcode-reader';
    import io from 'socket.io-client';
    import vPagination from 'vue-plain-pagination'
    import Dark from "@/components/Dark.vue";
    export default {
        name: 'Home',
        components: {
            datetime: Datetime,
            Sidebar,
            Mobilebar,
            Multiselect :Multiselect ,
            QrcodeStream,
            Navbar,
            vPagination,
            Dark
        },
        data() {
            return {
                unitDescSelected:'x',
                analogBoardSelected:false,
                unitDesc:'x',
                analogBoard:false,
                showTable:false,
                displayMessages2:false,
                showErrorMessage2:false,
                showSuccessMessage2:false,
                showInfoMessage2:false,
                displayMessages: false,
                showErrorMessage: false,
                errorMessage: null,
                showSuccessMessage: false,
                successMessage: null,
                showInfoMessage: false,
                successInfo: null,
                showBottomBar: true,
                showMobile: false,
                showLogo: false,
                showNav: false,
                counterDanger: false,
                workDate:'',
                tech:'',
                jobName:'',
                po:'',
                contactName:'',
                contactNumber:'',
                issueReported:'',
                description:'',
                timeZ: Intl.DateTimeFormat().resolvedOptions().timeZone,
                dates:[],
                startTime:'',
                stopTime:'',
                tickets: [],
                token:'8317829b00b26102bbd95f89401049f0',
                totalEvents:0,
                totalRepair:0,
                totalClosed:0,
                ptrack:false,
                selectedTicket:0,
                selectedSn:0,
                selectedObject:[],
                trackHistory:[],
                eventDate:'',
                counterDanger2:false,
                aditionalNotes:'',

                pDelTicket:false,

                pDetails:false,
                destroyed: false,
                result:'',
                openCamera:false,
                device:'',
                pCamera:false,
                socket:'',


                sCompany:'x',
                sCompanies:[],
                sJobs:[],
                sPo:'',
                sJob:'x',
                sSn:'',
                sTech:'',

                statusTicketChange:0,
                statusTicket:1,
                companyNameChange:'',
                jobNameChange:'',

                url: '',
                apiNickname: '',
                user: '',
                name: '',
                apiObject: [],
                apiObject2: [],
                apiObjectLength: 0,
                totalUsers: 0,
                editName: '',
                editApi: '',
                editIndex: '',
                dbname: '',
                dbpass: '',
                dbuser: '',
                nName: '',
                nEmail: '',
                nPass: '',
                lvl: 0,
                nConfirm: '',
                nDbName: '',
                nDbUser: '',
                nDbPass: '',
                eDbName: '',
                eDbUser: '',
                eDbPass: '',
                eLvl: 0,
                eIndex: '',
                eStatus: false,
                liveApi: 0,
                seeUid:'',
                seeObj:[],
                messageCopy:'',
                showCopy:false,
                currentx: 1,
                totalTickets:0,
                level:0,
                serialNumber:0,
                tickeId:0,
                ticketStatus:0,
                sendDate:null,
                invJobName:null,
                invNotes:null,
                contactNameSelected:'',
                contactNumberSelected:'',
                descriptionSelected:'',
                idSelected:'',
                issueReportedSelected:'',
                jobNameSelected:'',
                poSelected:'',
                snSelected:'',
                statusSelected:'',
                statusLabelSelected:'',
                techSelected:'',
                workDateSelected:'',
                moreStart:'',
                moreStop:'',
                remEmail:null
            };
        },

        created() {
            var vm= this


            console.log('Router:', this.$router.currentRoute.params)

            if(this.$router.currentRoute.params.id && this.$router.currentRoute.params.ticketId){
                this.serialNumber= this.$router.currentRoute.params.id
                this.ticketId= this.$router.currentRoute.params.ticketId
                this.ticketStatus= this.$router.currentRoute.params.ticketStatus
                this.sendDate= this.$router.currentRoute.params.sendDate
                this.invJobName= this.$router.currentRoute.params.invJobName
                this.invNotes= this.$router.currentRoute.params.invNotes
            }else{
                this.serialNumber= 0
                this.ticketId= 0
            }
            console.log('route', this.serialNumber);

            vm.socket =  io.connect('https://quantumsync.org:3003/');
            vm.socket.on("openTicket", (data) => {
                let obj= JSON.parse(data)
                if(obj){
                    vm.seeDetailScan(obj.ticket, obj.uid, obj.device)
                }

            });

            
        },

        mounted() {
            var vm= this


            vm.getWork(1)
            vm.isMobile()
            vm.getTotalEvents()
            vm.getCompanies()


            vm.dates=[]

            //setTimeout(() => {
                // vm.socket =  io.connect('https://quantumsync.org:3003/');
                // vm.socket.on ('openTicket', function (data) {
                //     vm.seeDetailScan(data.ticket, data.uid, data.device)
                // });
                // vm.socket.on ('', function (data) {
                //     var algo = JSON.stringify()
                // });
           // }, 4000);




            
            firebaseApp.auth().onAuthStateChanged(function(user) {
                if (user) {
                    firebaseApp.database().ref(`users/${user.uid}`)
                    .orderByChild('email')
                    .once('value', function(snapshot){
                        snapshot.forEach(function(child){ 
                            // const element  = child.val().lvl;
                            const element  = child.val();
                            if(element.lvl==1){
                                vm.$router.push( '/Main' );
                            }else{
                                vm.remEmail = user.email
                                vm.getInitialData();
                            }
                        });
                    })  
                }
            });
            
        },
        watch: {
            currentx: function (e) {
                this.currentx = e
                this.getWork(this.currentx)
            }
        },
        methods: {

            closeMobileBar(){
                // this.showMobile=false
            },
            displaySuccess2(message) {
                var vm = this
                vm.displayMessages2 = true
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (vm.showSuccessMessage2) {
                    vm.showSuccessMessage2 = false
                }
                vm.showSuccessMessage2 = true
                vm.successMessage2 = `✅${message}`
                setTimeout(() => {
                    vm.showSuccessMessage2 = false
                    vm.displayMessages2 = false
                }, 3000);
            },

                    
            displayError2(error) {
                var vm = this
                vm.displayMessages2 = true
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (vm.showErrorMessage2) {
                    vm.showErrorMessage2 = false
                }
                vm.showErrorMessage2 = true
                vm.errorMessage2 = `❌${error}`
                setTimeout(() => {
                    vm.showErrorMessage2 = false
                    vm.displayMessages2 = false
                }, 3000);
            },
            

            displayError(error) {
                var vm = this
                vm.displayMessages = true
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (vm.showErrorMessage) {
                    vm.showErrorMessage = false
                }
                vm.showErrorMessage = true
                vm.errorMessage = `❌${error}`
                setTimeout(() => {
                    vm.showErrorMessage = false
                    vm.displayMessages = false
                }, 3000);
            },

            displaySuccess(message) {
                var vm = this
                vm.displayMessages = true
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (vm.showSuccessMessage) {
                    vm.showSuccessMessage = false
                }
                vm.showSuccessMessage = true
                vm.successMessage = `✅${message}`
                setTimeout(() => {
                    vm.showSuccessMessage = false
                    vm.displayMessages = false
                }, 3000);
            },


            async delTime(id, repairId){
                var vm =this

                
                const bodyParameters = {
                    id: id,
                    repairId: repairId
                };
                this.trackHistory=[]

                await axios.post(`https://quantumsync.org/api-agt/index.php?delTime=true`, bodyParameters)
                .then(function (response) {    
                    console.log('Success')
                    vm.trackHistory = response.data
                    vm.moreStart=""
                    vm.moreStop=""
                    return;
                })
                .catch(function (error) {
                    vm.displayError2(error);
                })

            },

            async addMoreTime(){
                var vm =this
                

                if (this.moreStart.length == 0)	 {
                    this.displayError2("Start time date is empty")
                    return;
                }
               
                if (this.moreStop.length == 0)	 {
                    this.displayError2("Stop time date is empty")
                    return;
                }

                const bodyParameters = {
                    repairId: vm.idSelected,
                    start: vm.moreStart,
                    stop: vm.moreStop
                };

                this.trackHistory=[]

                await axios.post(`https://quantumsync.org/api-agt/index.php?addTime=true`, bodyParameters)
                .then(function (response) {    
                    console.log(response.data)
                    vm.trackHistory = response.data
                    vm.moreStart=""
                    vm.moreStop=""
                    return;
                })
                .catch(function (error) {
                    vm.displayError2(error);
                })
          
            
            },

            delDate(index){

                this.dates.splice(index, 1); 
            },

            addDate(){
                if (this.startTime.length == 0)	 {
                    this.sendNotify("Error", "Start time date is empty", "danger", "highlight_off");
                    return;
                }
               
                if (this.stopTime.length == 0)	 {
                    this.sendNotify("Error", "Stop time date is empty", "danger", "highlight_off");
                    return;
                }
               
                let obj ={
                    startTime: this.startTime,
                    stopTime: this.stopTime
                }
                this.dates.push(
                    obj
                )
                this.startTime=''
                this.stopTime=''
            },

            async filterBy(type){
                var vm =this
                var status=1
                switch (type) {
                                case "opened":
                                    status= 1;
                                    break;
                                case "inRepair":
                                    status= 2;
                                    break;
                                case "closed":
                                    status= 3;
                                    break;
                            
                                default:
                                    break;
                            }

                const bodyParameters = {
                    status: status
                };


                await axios.post(`https://quantumsync.org/api-agt/index.php?searchWorkFilter=true`, bodyParameters)
                .then(function (response) {    
                    vm.tickets=[]              
                    vm.totalTickets= response.data[0].totalRows
                    vm.getTotalEvents()
                    response.data.forEach(function (element, i) {
                        if(i>0){
                            switch (element.status) {
                                case "1":
                                    element.statusLabel= 'Opened';
                                    break;
                                case "2":
                                    element.statusLabel= 'In repair';
                                    break;
                                case "3":
                                    element.statusLabel= 'Closed';
                                    break;
                            
                                default:
                                    break;
                            }
                            vm.tickets.push(element)
                        }
                    });
                    window.scrollTo(0, document.body.scrollHeight);

                    return;
                })
                .catch(function (error) {
                    vm.displayError(error);
                })

            },

            async verifySerialNumber(){
                var vm = this
                if(vm.sn.length>=0){
                    await axios.post('https://quantumsync.org:3000/api/verifySerialNumber', {
                        sn: vm.sn
                    })
                    .then(function (response) {    
                       let data = response.data
                       if(data[0]){
                            if(data[0].total>0){
                                vm.sendNotify("Error", "You have this serial number already used, please verify it in search table.", "danger", "highlight_off");
                                vm.sn =""
                                return
                            }
                       }
                    })
                    .catch(function (error) {
                        vm.sendNotify("Error", error, "danger", "highlight_off");
                    })
                }
            },


            resetTable(){
                this.sSn="" 
                this.sPo=""
                this.sJob="x"
                this.serialNumber="0"
                this.getWork(1)
                this.sendNotify("Success", "The table has been reset", "success", "highlight_off");
                return;
            },


            async search(){
                var vm =this
                var sPo="x"
                var sSn="x"
                var sTech="x"
                if (vm.sPo.length != 0) {
                    sPo= vm.sPo
                }
                if (vm.sSn.length != 0) {
                    sSn= vm.sSn
                }
                if (vm.sTech.length != 0) {
                    sTech= vm.sTech
                }

                if(sSn=="x" && sPo=="x" && vm.sJob=="x" && vm.sTech=="x"){
                    vm.displayError("Please select or type at least one value");
                    return
                }


                const bodyParameters = {
                    sPo: sPo,
                    sSn:  sSn,
                    sCompany:  vm.sCompany,
                    sJob:  vm.sJob,
                    sTech:  vm.sTech
                };


                await axios.post(`https://quantumsync.org/api-agt/index.php?searchWork=true`, bodyParameters)
                .then(function (response) {    
                    vm.tickets=[]              
                    vm.totalTickets= response.data[0].totalRows
                    vm.getTotalEvents()
                    response.data.forEach(function (element, i) {
                        if(i>0){
                            switch (element.status) {
                                case "1":
                                    element.statusLabel= 'Opened';
                                    break;
                                case "2":
                                    element.statusLabel= 'In repair';
                                    break;
                                case "3":
                                    element.statusLabel= 'Closed';
                                    break;
                            
                                default:
                                    break;
                            }
                            vm.sSn="" 
                            vm.sPo=""
                            vm.sJob="x"
                            vm.tickets.push(element)
                        }
                    });
                    vm.displaySuccess("Data was found correctly");
                    return;
                })
                .catch(function (error) {
                    vm.sSn="" 
                    vm.sPo=""
                    vm.sJob="x"
                    vm.displayError(error);
                })


            },

            async getCompanies(){
                var vm =this
                vm.sJobs=[]
                await axios.get(`https://quantumsync.org/api-agt/index.php?getJobNames=true`)
                .then(function (response) {                  
                    let data = response.data

                    data.forEach(element => {
                        if(element.id==0){
                            vm.sJobs.push(element.jobName)
                        }
                    });
                })
                .catch(function (error) {
                    vm.sendNotify("Error", error, "danger", "highlight_off");
                })
            },


            async createChange(){
                const vm = this

                var user = localStorage.getItem('ufb')
                user = JSON.parse(user)
                
                if (vm.workDateSelected.length == 0)	 {
                    vm.displayError2("Date of Work Order date is empty");
                    return;
                }


                if (vm.techSelected.length == 0) {
                    vm.displayError2("Tech/Employee is empty");
                    return;
                }

                var regex = /^[A-Za-z0-9._\-@#$%&, ]+$/
                 var isValid = regex.test(vm.jobNameSelected);
                if (vm.jobNameSelected.length == 0) {
                    vm.displayError2("Job name is empty");
                    return;
                }

                 var isValidJob = regex.test(vm.jobNameSelected);
                if (!isValidJob) {
                    vm.jobNameSelected= ''
                    vm.displayError2("Job name contains special characters");
                    return;
                } 

                if (vm.poSelected.length == 0) {
                    vm.displayError2("PO # is empty");
                    return;
                }
                if (vm.contactNameSelected.length == 0) {
                    vm.displayError2("Contact name is empty");
                    return;
                }
               
                if (vm.contactNumberSelected.length == 0) {
                    vm.displayError2("Contact number is empty");
                    return;
                }
               
                if (vm.issueReportedSelected.length == 0) {
                    vm.displayError2("Issue reported is empty");
                    return;
                }
                if (vm.issueReportedSelected.length > 250) {
                    vm.displayError2("Issue reported is too large");
                    return;
                }
    

                if (vm.descriptionSelected.length == 0) {
                    vm.displayError2("Description of Work Done is empty");
                    return;
                }
                if (vm.descriptionSelected.length > 1000) {
                    vm.displayError2("Description of Work Done is too large");
                    return;
                }


                  if (vm.unitDescSelected == "x") {
                    vm.displayError("Please select a value for Unit Description");
                    return;
                }

                let analogBoard = 0;
                if (vm.analogBoardSelected) {
                    analogBoard = 1;
                }
                

                

                const bodyParameters = {
                    contactName: vm.contactNameSelected,
                    contactNumber: vm.contactNumberSelected,
                    description: vm.descriptionSelected,
                    id: vm.idSelected,
                    issueReported: vm.issueReportedSelected,
                    jobName: vm.jobNameSelected,
                    po: vm.poSelected,
                    status: vm.statusTicketChange,
                    tech: vm.techSelected,
                    unitDesc: vm.unitDescSelected,
                    analogBoard: analogBoard
                };

                var statusName = "--";
                var messageSms=''
                if(parseInt(vm.statusTicketChange)==1){statusName="🚀opened"};
                if(parseInt(vm.statusTicketChange)==2){statusName="🧰in repair"};
                if(parseInt(vm.statusTicketChange)==3){
                    statusName="✅closed"
                     messageSms = `From: In Office, ${user.displayName} has closed a work order with ticket: ${vm.idSelected}`
                };


                await axios.post(
                 "https://quantumsync.org/api-agt/index.php?makeWorkChanges=true",
                 bodyParameters
                ).then((response)=>{
                    console.log(response)
                    if(response.data){
                        axios.post(
                         "https://quantumsync.org:3003/api/sendNotification",{
                                message: `${user.displayName} has changed to ${statusName} in work orders with repairID: ${vm.idSelected}`,
                                from: "🛠️In-Office-Work-Orders"
                        }
                        ).then((response)=>{
                            vm.pDetails= false
                            if(parseInt(vm.statusTicketChange)==3){
                                vm.sendSMS(messageSms)
                            }

                            vm.getWork(1)
                            vm.getTotalEvents()
                            vm.getCompanies()
                            window.scrollTo(0, document.body.scrollHeight);
                        })
                        .catch((err)=>{
                            vm.pDetails= false
                            vm.getWork(1)
                            vm.getTotalEvents()
                            vm.getCompanies()
                            window.scrollTo(0, document.body.scrollHeight);
                        });
                        return;
                    }
                }).catch((err)=>{
                    vm.displayError2(err);
                    return;
                });
                

            },

            async sendSMS(message){
                const bodyParameters = {
                    message:  message
                };
                await axios.post('https://quantumsync.org:3003/api/sendSms', 
                 bodyParameters
                ).then((response)=>{
                    if(response.data){
                        console.log(response.data)
                        return;
                    }
                }).catch((err)=>{
                    console.log(err)
                    vm.displayError(err);
                    return;
                });
            },

            openCam(){
                // if(this.device=='phone'){
                   // navigator.vibrate(500);
                    this.openCamera=true
                // }else{
                //     this.sendNotify("Error", "You can't use PC to scan something", "danger", "highlight_off");
                //     this.openCamera=false
                // }
                 
            },

            async getSingleTicket(ticket){
                var vm = this
                const bodyParameters = {
                    tickeId: ticket,
                };
                await axios.post(`https://quantumsync.org/api-agt/index.php?getsingleTicket=true`, bodyParameters)
                .then(function (response) {         
                    vm.selectedObject= response.data[0]       
                })
                .catch(function (error) {
                    vm.sendNotify("Error", error, "danger", "highlight_off");
                })
            },

            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    this.device = 'phone'
                    return true
                } else {
                    this.device= 'desk'
                    return false
                }
            },


            onDecode (result) { 

                var vm = this

                var user = localStorage.getItem('ufb')
                user = JSON.parse(user)

                // if(this.device=='phone'){
                   // navigator.vibrate(500);
                    this.result = result
                    console.log('Scanned....................',this.result)
                    this.socket.emit('send_ticket', { uid: user.uid, ticket: this.result, device: this.device })

                    this.openCamera=false



                    vm.socket =  io.connect('https://quantumsync.org:3003/');
                    vm.socket.on("openTicket", (data) => {
                        console.log('RECEIVED OPEN TICKET')
                        let obj= JSON.parse(data)
                        if(obj){
                            vm.seeDetailScan(obj.ticket, obj.uid, obj.device)
                        }

                    });


                    // this.seeDetailScan(this.result)
                // }else{
                //     this.sendNotify("Error", "You can't use PC to scan something", "danger", "highlight_off");
                //     this.openCamera=false
                // }
                 
            },
            async onInit (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                    this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                    this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                    this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                    this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                    this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                    this.error = "ERROR: Stream API is not supported in this browser"
                    }
                }
            },

            printOrder(ticket){
                window.open(`https://quantumsync.org:3003/api/pwo/${ticket}`, '_blank');
            },

            async getPic(ticket){
                var vm =this
                
                window.location.assign(`https://quantumsync.org:3003/tag/${ticket}`);
                
                setTimeout(() => {
                    vm.$vs.loading.close()
                }, 3000);
                    return
                await axios.get(`https://quantumsync.org:3003/tag/${ticket}`)
                .then(function (response) {                  
                    window.location.assign(`https://quantumsync.org:3003/tag/${ticket}`);
                    vm.$vs.loading.close()
                })
                .catch(function (error) {
                    vm.sendNotify("Error", error, "danger", "highlight_off");
                })
            },


            async seeDetails(tr){
                var vm = this
                console.log(tr)
                this.selectedObject= tr

                this.contactNameSelected = tr.contactName
                this.contactNumberSelected = tr.contactNumber
                this.descriptionSelected = tr.description
                this.idSelected = tr.id
                this.issueReportedSelected = tr.issueReported
                this.jobNameSelected = tr.jobName
                this.poSelected = tr.po
                this.snSelected = tr.sn
                this.statusSelected = tr.status
                this.statusLabelSelected = tr.statusLabel
                this.techSelected = tr.tech
                this.workDateSelected = tr.workDate
                this.unitDescSelected = tr.unitDesc
                this.analogBoardSelected = false;
                if(parseInt(tr.analogBoard)==1){
                    this.analogBoardSelected = true;
                }

                this.selectedTicket= tr.id
                window.scrollTo({ top: 0, behavior: 'smooth' });
                this.pDetails= true
                this.statusTicketChange= tr.status

                const bodyParameters = {
                    repairId: tr.id,
                };
                await axios.post(
                 "https://quantumsync.org/api-agt/index.php?getWorkDetails=true",
                 bodyParameters
                ).then((response)=>{
                    if(response.data){
                    console.log(response.data)
                        vm.trackHistory= response.data
                        return;
                    }
                }).catch((err)=>{
                    vm.sendNotify("Error", err, "danger", "highlight_off");
                    return;
                });

            },
            
            seeDetailScan(ticket, uid, device){
                var vm = this

                var user = localStorage.getItem('ufb')
                user = JSON.parse(user)


                if(user.uid ==uid){

                    // if(device=='desk'){
                        this.openCamera=false
                        this.getSingleTicket(ticket)
                        this.selectedTicket= ticket

                        setTimeout(() => {
                            
                            this.pDetails= true
                        }, 1000);


                        const bodyParameters = {
                            tickeId: ticket,
                        };
                        axios.post(
                         "https://quantumsync.org/api-agt/index.php?getDetails=true",
                         bodyParameters
                        ).then((response)=>{
                            if(response.data){
                                vm.trackHistory= response.data
                                return;
                            }
                        }).catch((err)=>{
                            vm.sendNotify("Error", err, "danger", "highlight_off");
                            return;
                        });
                    // }else{
    
                    // }
                }

                

            },


            addDetails(){
                const vm = this

                if (vm.eventDate.length == 0)	 {
                    vm.sendNotify("Error", "Event date is empty", "danger", "highlight_off");
                    return;
                }
               
                var po = '--'
                if (vm.po.length >0)	 {
                    po = vm.po
                }

                var user = localStorage.getItem('ufb')
                user = JSON.parse(user)
                var regex = /^[A-Za-z0-9._\-@#$%&, ]+$/
                var isValid = regex.test(vm.aditionalNotes);
                // if (!isValid) {
                //     vm.aditionalNotes= ''
                //     vm.sendNotify("Error", "Aditional notes contains special characters", "danger", "highlight_off");
                //     return;
                // } 

                if (vm.aditionalNotes.length == 0) {
                    vm.sendNotify("Error", "Aditional notes is empty", "danger", "highlight_off");
                    return;
                }


                const bodyParameters = {
                    tickeId: vm.selectedTicket,
                    eventDate:  vm.eventDate,
                    details:  vm.aditionalNotes,
                    user:  user.email,
                    po:  po
                };
                axios.post(
                 "https://quantumsync.org/api-agt/index.php?addDetails=true",
                 bodyParameters
                ).then((response)=>{
                    if(response.data){
                        vm.sendNotify("Success", "Details added successfully", "success", "highlight_off");
                        vm.selectedTicket=''
                        vm.eventDate= ''
                        vm.aditionalNotes= ''
                        vm.sentDate= ''
                        vm.po= ''
                        vm.ptrack= false
                        vm.getWork(1) 
                        vm.getTotalEvents()
                        vm.seeDetails(vm.selectedObject)
                        return;
                    }
                }).catch((err)=>{
                    vm.sendNotify("Error", err, "danger", "highlight_off");
                    return;
                });


            },

            addTrack(ticket){
                this.selectedTicket= ticket
                this.ptrack= true

            },

            confirmDel(){
                var vm = this
                const bodyParameters = {
                    id: vm.selectedTicket
                };
                axios.post(
                 "https://quantumsync.org/api-agt/index.php?delWork=true",
                 bodyParameters
                ).then((response)=>{
                    if(response.data){
                        vm.displaySuccess("Repair deleted successfully");
                        vm.selectedTicket=''
                        vm.pDelTicket= false
                        vm.getWork(1)
                        vm.getTotalEvents()
                        vm.getCompanies()
                        return;
                    }
                }).catch((err)=>{
                    vm.displayError(err);
                    return;
                });
            },

            
            delTicket(id, sn){
                this.selectedTicket= id
                this.selectedSn= sn
                this.pDelTicket= true

                setTimeout(() => {
                    var targetElm = document.querySelector('.dDel')
                    targetElm.scrollIntoView({behavior: "smooth", block: "center", inline: "center"})
                }, 100);
            },

            registerTicket(){
                const vm = this

                // workDate
                // tech
                // jobName
                // po
                // contactName
                // contactNumber
                // issueReported
                // description
                // dates


                if (vm.workDate.length == 0)	 {
                    vm.displayError("Date of Work Order date is empty");
                    return;
                }


                if (vm.tech.length == 0) {
                    vm.displayError("Tech/Employee is empty");
                    return;
                }

                var regex = /^[A-Za-z0-9._\-@#$%&, ]+$/
                 var isValid = regex.test(vm.jobName);
                if (vm.jobName.length == 0) {
                    vm.displayError("Job name is empty");
                    return;
                }

                 var isValidJob = regex.test(vm.jobName);
                if (!isValidJob) {
                    vm.jobName= ''
                    vm.displayError("Job name contains special characters");
                    return;
                } 

                if (vm.po.length == 0) {
                    vm.displayError("PO # is empty");
                    return;
                }
                if (vm.contactName.length == 0) {
                    vm.displayError("Contact name is empty");
                    return;
                }
               
                if (vm.contactNumber.length == 0) {
                    vm.displayError("Contact number is empty");
                    return;
                }
               
                if (vm.issueReported.length == 0) {
                    vm.displayError("Issue reported is empty");
                    return;
                }
                if (vm.issueReported.length > 250) {
                    vm.displayError("Issue reported is too large");
                    return;
                }
                // if (vm.dates.length == 0) {
                //     vm.displayError("You must select at least one start/stop date");
                //     return;
                // }

                if (vm.description.length == 0) {
                    vm.description = ""
                }
                if (vm.description.length > 1000) {
                    vm.displayError("Description of Work Done is too large");
                    return;
                }

                //  var isValidSentNotes = regex.test(vm.sentNotes);
                // if (!isValidSentNotes) {
                //     vm.sentNotes= ''
                //     vm.sendNotify("Error", "Sent notes contains special characters", "danger", "highlight_off");
                //     return;
                // } 

     


                if(vm.unitDesc=="x"){
                    vm.displayError("Please select a value for Unit Description");
                    return;
                }

                let analogBoard=0;
                if(vm.analogBoard){
                    analogBoard=1;
                }


                
                

                const bodyParameters = {
                    serialNumber: vm.serialNumber,
                    workDate: vm.workDate,
                    tech: vm.tech,
                    jobName: vm.jobName,
                    po: vm.po,
                    contactName: vm.contactName,
                    contactNumber: vm.contactNumber,
                    issueReported: vm.issueReported,
                    description: vm.description,
                    dates: vm.dates,
                    unitDesc: vm.unitDesc,
                    analogBoard: analogBoard,
                    status: vm.statusTicket
                };
                axios.post(
                 "https://quantumsync.org/api-agt/index.php?registerWork=true",
                 bodyParameters
                ).then((response)=>{
                    if(response.data){
                    if(response.data){
                            if(response.data.id){
                                axios.post(
                                 "https://quantumsync.org:3003/api/sendNotification",{
                                        message: `${vm.tech} has 🚀opened a new work order with repairID: ${response.data.id}`,
                                        from: "🛠️In-Office-Work-Orders"
                                }
                                ).then((response)=>{
                                    console.log('segunda respuesta')
                                    console.log(response)
                                })
                                .catch((err)=>{
                                    console.log(err)
                                });
                            }
                            vm.workDate=""
                            vm.tech=""
                            vm.jobName=""
                            vm.po=""
                            vm.contactName=""
                            vm.contactNumber=""
                            vm.issueReported=""
                            vm.description=""
                            vm.dates=[]
                            vm.getWork(1)
                            vm.getCompanies()
                            
                            return;
                        }
                    }
                }).catch((err)=>{
                    vm.displayError(err)
                });

            },


            getTotalEvents(){
                var vm = this
                axios.get('https://quantumsync.org/api-agt/index.php?getTotalWorkEvents=true')
                .then(function (response) {
                    vm.totalEvents=response.data[0].opened
                    vm.totalRepair=response.data[1].repair
                    vm.totalClosed=response.data[2].closed
                })
                .catch(function (error) {
                    vm.sendNotify("Error", `Something went wrong ${error}`, "danger", "highlight_off");
                    return;
                })
            },

            getWork(page) {
                var vm = this
                vm.tickets=[]
                const bodyParameters = {
                    page:  page,
                    serialNumber: vm.serialNumber
                };
                // axios.post('http://ec2-3-88-19-50.compute-1.amazonaws.com:3000/api/getWork',{
                axios.post('https://quantumsync.org/api-agt/index.php?getWorks=true',
                    bodyParameters
                )
                .then(function (response) {
                    vm.totalTickets= response.data[0].totalRows
                    setTimeout(() => {
                        vm.showTable=true
                    }, 200);
                    vm.getTotalEvents()
                    response.data.forEach(function (element, i) {
                        if(i>0){
                            switch (element.status) {
                                case "1":
                                    element.statusLabel= 'Opened';
                                    break;
                                case "2":
                                    element.statusLabel= 'In repair';
                                    break;
                                case "3":
                                    element.statusLabel= 'Closed';
                                    break;
                            
                                default:
                                    break;
                            }
                            vm.tickets.push(element)
                        }
                    });
                    return;
                })
                .catch(function (error) {
                    vm.sendNotify("Error", `Something went wrong ${error}`, "danger", "highlight_off");
                    return;
                })
            },

            toggleMenu() {
                this.showBottomBar = !this.showBottomBar
                if (this.showBottomBar) {
                    this.showLogo = false
                } else {
                    this.showLogo = true
                }
            },
            toggleMobile() {
                // this.showMobile = !this.showMobile
                this.$router.push('/mobile');
            },


            dbConfig() {
                this.$refs.initModal.open()
            },

            getInitialData() {
                var vm = this
                
                firebaseApp.auth().onAuthStateChanged(function (user) {
                    if (!user) {
                        vm.$router.push('/');
                    } else {
                        vm.user = user.uid
                        firebaseApp.database().ref('users/' + user.uid).once("value", function (snapshot) {
                            var data = snapshot.val();
                            vm.level= data.lvl
                            vm.name = data.name
                            vm.dbname = data.dbname
                            vm.dbuser = data.dbuser
                            vm.dbpass = data.dbpass
                            if (data.api) {
                                vm.apiObject = data.api
                                vm.apiObjectLength = vm.apiObject.length
                            }
                        }, function (errorObject) {
                            vm.sendNotify(
                                "Error",
                                `Something went wrong ${errorObject}`,
                                "error",
                                "highlight_off"
                            );
                            return;
                        });
                    }
                });
            },


            openLoadingBackground() {
                this.$vs.loading({ background: 'rgb(0,0,0,0.3)', color: 'rgb(255, 255, 255)' })
                setTimeout(() => {
                    this.$vs.loading.close()
                    this.loading = true
                }, 1000);
            },

            openLoadingBackground2() {
                this.$vs.loading({ background: 'rgb(0,0,0,0.3)', color: 'rgb(255, 255, 255)' })
            },

            logOut() {
                this.loading = false
                firebaseApp.auth().signOut()
            },
            sendNotify(title, text, color, icon) {
                this.$vs.notify({
                    title: title,
                    text: text,
                    color: color,
                    icon: icon
                });
                /*highlight_off error*/
            },
        },
        props: {
            msg: String
        }
    }
</script>

<style>

    .ticketLink{
        color: #075cff !important;
        font-weight: 600 !important;
        text-decoration: underline !important;

    }

    
    .collapse {
        display: hide !important;
    }

    .custom-bg {
        /* background: url('~@/assets/wall.jpg') !important; */
        background: linear-gradient(56deg, rgba(226,255,253,1) 0%, rgba(255,210,215,1) 100%) !important;

        -webkit-background-size: cover !important;
        -moz-background-size: cover !important;
        -o-background-size: cover !important;
        background-size: cover !important;
        background-position: center center !important;
        background-repeat: no-repeat !important;
        background-attachment: fixed !important;
    }

    .vs-pagination--ul {
        margin-bottom: 0px !important;
    }

    .vs-table--search{
        margin-right: 10px !important;
    }


</style>